import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'client_applications';

export default {
  state: {
    all: []
  },

  mutations: {
    setAllClientApplications(state, clientApplications) {
      state.all = clientApplications;
    },

    addClientApplication(state, clientApplication) {
      state.all.push(clientApplication);
    }
  },

  actions: {
    fetchClientApplications({ commit }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          const apps = _.map(resp.data.data, (ca) => {
            ca.attributes.access_tokens = _.map(
              _.select(resp.data.included, (inc) => {
                return inc.type === "access-tokens" && inc.attributes.client_application_id === ca.attributes.id;
              }),
              (t) => t.attributes
            );

            return ca.attributes;
          });

          commit("setAllClientApplications", apps);
        })
        .catch((err) => console.error("Failed to fetch client applications", err));
    },

    createClientApplication({ commit }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          const app = resp.data.data.attributes;
          app.access_tokens = [];
          _.each(resp.data.included, (inc) => {
            if (inc.type === "access-tokens") {
              app.access_tokens.push(inc.attributes);
            }
          });

          commit("addClientApplication", app);

          return app;
        });
    },

    attachAcessTokens(app, included) {
      console.log("ATTACH TOKENS", app, included);
      return app;
    }
  }
};
